import {
  faLocationPinLock,
  faHouse,
  faSearch,
  faChartArea,
  faEnvelope,
  faArrowAltCircleLeft,
  faSquareArrowUpRight,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { SubMenu, MenuItem } from "react-pro-sidebar";
import { Link } from "react-router-dom";
import { TSLandingPage } from "../components/TSLandingPage";
import { Page } from "@thoughtspot/visual-embed-sdk";
import { AppEmbedWrapper } from "../components/AppEmbed/AppEmbedWrapper";
import Layout from "../components/Layout";
import SecureRoute from "../components/SecureRoute";
import { DefaultSidebarBreakpoint } from "../components/SidebarToggle";
import { appEmbedWrapperCssRules } from "../cssRules";
import { ContactUs } from "../pages/contactus/ContactUs";
import { SignOut } from "../pages/sign-out/SignOut";
import {
  SubdomainOrgIdObject,
  subMenuDefaultProps,
} from "./FunctionsAndInterfaces";

const orgId: number = 1865786808;
const subDomain: string = "celink";
const nameOfProduct: string = "CK";
const secureRouteGroups: string[] = ["Celink"];

export const celinkObject: SubdomainOrgIdObject = {
  orgID: orgId,
  path: subDomain,
};

export const celinkLandingPage = (
  <TSLandingPage
    smallButtons={true}
    parentURL={`/${subDomain}/product`}
    buttons={[
      [
        { title: "Search", description: "", link: "answer" },
        { title: "Liveboards", description: "", link: "pinboards/" },
      ],
      [
        {
          title: "Call Monitoring",
          description: "",
          link: "pinboard/7e9c61f8-99a2-4e46-82aa-c9b981c61dc7",
          backgroundImageName: "/Phone.png",
        },
        {
          title: "LOC Disbursements",
          description: "",
          link: "pinboard/492b5e20-d336-4afb-b8d1-dd9bd8a02b71",
          backgroundImageName: "/OldBuilding.png",
        },
      ],
      [
        {
          title: "Payoff Quotes",
          description: "",
          link: "pinboard/3c394e6a-1342-4d42-b692-1f4059da3a6e",
          backgroundImageName: "/Contract.png",
        },
        {
          title: "Appraisal Monitoring",
          description: "",
          link: "pinboard/023dbfcb-a2ee-4385-a542-5047ec4ad6d0",
          backgroundImageName: "/PercentageHouse.png",
        },
      ],
      [
        {
          title: "Inspections",
          description: "",
          link: "pinboard/d66a0c1c-6747-4835-8bcd-c752bfd14c63",
          backgroundImageName: "/House.png",
        },
        {
          title: "QC Testing",
          description: "",
          link: "pinboard/238f9ff1-2747-4337-baf9-61ad2aab8302",
          backgroundImageName: "/Clipboard.png",
        },
      ],
      [
        {
          title: "Fees",
          description: "",
          link: "pinboard/2195eafc-0380-48ea-a1c4-7cec60a2398e",
          backgroundImageName: "/DollarBill.png",
        },
        {
          title: "Client Billing",
          description: "",
          link: "pinboard/ff6adbd4-e5aa-4dbd-99cc-50846c9bd31c",
          backgroundImageName: "/Bill.png",
        },
      ],
    ]}
  />
);

const sidebarMenu = () => {
  return (
    <>
      <SubMenu
        {...subMenuDefaultProps}
        title={"Main Menu"}
        icon={<FontAwesomeIcon className="me-2" icon={faLocationPinLock} />}
      >
        <MenuItem>
          <Link to={`/${subDomain}`}>
            <div className="sidebar-item">
              <FontAwesomeIcon className="me-2" icon={faHouse} />
              Home
            </div>
          </Link>
        </MenuItem>
        <MenuItem>
          <Link to={`/${subDomain}/product?productURL=answer&fromMenu=true`}>
            <div className="sidebar-item">
              <FontAwesomeIcon className="me-2" icon={faSearch} />
              Search
            </div>
          </Link>
        </MenuItem>
        <MenuItem>
          <Link
            to={`/${subDomain}/product?productURL=pinboards&fromMenu=true`}
            state={{ isLiveboard: false, link: "pinboards/" }}
          >
            <div className="sidebar-item">
              <FontAwesomeIcon className="me-2" icon={faChartArea} />
              Liveboards
            </div>
          </Link>
        </MenuItem>
        <MenuItem>
          <Link to={`/${subDomain}/contactus`}>
            <div className="sidebar-item">
              <FontAwesomeIcon className="me-2" icon={faEnvelope} />
              Contact Us
            </div>
          </Link>
        </MenuItem>
        <MenuItem>
          <Link to={`/${subDomain}/signout`}>
            <div className="sidebar-item">
              <FontAwesomeIcon className="me-2" icon={faArrowAltCircleLeft} />
              Log Out
            </div>
          </Link>
        </MenuItem>
      </SubMenu>
      <SubMenu
        {...subMenuDefaultProps}
        title={"Reports"}
        icon={<FontAwesomeIcon className="me-2" icon={faChartArea} />}
      >
        <MenuItem>
          <Link
            to={`/${subDomain}/product?productURL=pinboard/023dbfcb-a2ee-4385-a542-5047ec4ad6d0&fromMenu=true`}
          >
            <div className="sidebar-item">
              <FontAwesomeIcon className="me-2" icon={faSquareArrowUpRight} />
              Appraisal Monitoring
            </div>
          </Link>
        </MenuItem>
        <MenuItem>
          <Link
            to={`/${subDomain}/product?productURL=pinboard/7e9c61f8-99a2-4e46-82aa-c9b981c61dc7&fromMenu=true`}
          >
            <div className="sidebar-item">
              <FontAwesomeIcon className="me-2" icon={faSquareArrowUpRight} />
              Call Monitoring
            </div>
          </Link>
        </MenuItem>
        <MenuItem>
          <Link
            to={`/${subDomain}/product?productURL=pinboard/ff6adbd4-e5aa-4dbd-99cc-50846c9bd31c&fromMenu=true`}
          >
            <div className="sidebar-item">
              <FontAwesomeIcon className="me-2" icon={faSquareArrowUpRight} />
              Client Billing
            </div>
          </Link>
        </MenuItem>
        <MenuItem>
          <Link
            to={`/${subDomain}/product?productURL=pinboard/2195eafc-0380-48ea-a1c4-7cec60a2398e&fromMenu=true`}
          >
            <div className="sidebar-item">
              <FontAwesomeIcon className="me-2" icon={faSquareArrowUpRight} />
              Fees
            </div>
          </Link>
        </MenuItem>
        <MenuItem>
          <Link
            to={`/${subDomain}/product?productURL=pinboard/d66a0c1c-6747-4835-8bcd-c752bfd14c63&fromMenu=true`}
          >
            <div className="sidebar-item">
              <FontAwesomeIcon className="me-2" icon={faSquareArrowUpRight} />
              Inspections
            </div>
          </Link>
        </MenuItem>
        <MenuItem>
          <Link
            to={`/${subDomain}/product?productURL=pinboard/492b5e20-d336-4afb-b8d1-dd9bd8a02b71&fromMenu=true`}
          >
            <div className="sidebar-item">
              <FontAwesomeIcon className="me-2" icon={faSquareArrowUpRight} />
              LOC Disbursements
            </div>
          </Link>
        </MenuItem>
        <MenuItem>
          <Link
            to={`/${subDomain}/product?productURL=pinboard/3c394e6a-1342-4d42-b692-1f4059da3a6e&fromMenu=true`}
          >
            <div className="sidebar-item">
              <FontAwesomeIcon className="me-2" icon={faSquareArrowUpRight} />
              Payoff Quotes
            </div>
          </Link>
        </MenuItem>
        <MenuItem>
          <Link
            to={`/${subDomain}/product?productURL=pinboard/238f9ff1-2747-4337-baf9-61ad2aab8302&fromMenu=true`}
          >
            <div className="sidebar-item">
              <FontAwesomeIcon className="me-2" icon={faSquareArrowUpRight} />
              QC Testing
            </div>
          </Link>
        </MenuItem>
      </SubMenu>
    </>
  );
};

export const celinkRoutes = {
  element: (
    <Layout
      breakPoint={DefaultSidebarBreakpoint}
      smallHeader={true}
      sidebarMenu={sidebarMenu()}
      contactUsPath={`/${subDomain}/contactus`}
      signOutPath={`/${subDomain}/signout`}
    />
  ),
  children: [
    {
      path: `/${subDomain}`,
      element: (
        <SecureRoute
          productName={nameOfProduct}
          element={celinkLandingPage}
          groups={secureRouteGroups}
        />
      ),
    },
    {
      path: `/${subDomain}/product`,
      element: (
        <SecureRoute
          productName={nameOfProduct}
          element={
            <AppEmbedWrapper
              cssRules={appEmbedWrapperCssRules}
              breakPoint={DefaultSidebarBreakpoint}
              showPrimaryNavbar={true}
              disableProfileAndHelp={true}
              className="ts-full-app h-100"
              pageId={Page.Liveboards}
              orgObject={celinkObject}
            />
          }
          groups={secureRouteGroups}
        />
      ),
    },
    {
      path: `/${subDomain}/contactus`,
      element: <ContactUs />,
    },
    {
      path: `/${subDomain}/signout`,
      element: <SignOut />,
    },
  ],
};
